module.exports = __webpack_public_path__ + "img/payment07.5bd6451a.png";